"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractId = void 0;
var buffer_1 = require("buffer");
var Serialization_1 = require("../../Handlers/Serialization");
var Hash_1 = require("./Hash");
var Contract_1 = require("./Contract");
var js_sha3_1 = require("js-sha3");
var BigInteger = require("bigi");
var ContractId = /** @class */ (function () {
    function ContractId(version, cHash) {
        this.version = version;
        this.cHash = cHash;
    }
    ContractId.fromString = function (string) {
        var bytes = buffer_1.Buffer.from(string, 'hex');
        if (bytes.length !== 36) {
            throw new Error('invalid contractId');
        }
        var version = bytes.readUInt32BE(0);
        var hash = Hash_1.Hash.read(bytes, 4).hash;
        return new ContractId(version, hash);
    };
    ContractId.makeContractId = function (contract) {
        if (contract instanceof Contract_1.V0) {
            var joinHashed = Hash_1.Hash.computeMultiples([
                Contract_1.V0.getVersionHash(),
                Contract_1.V0.getCodeHash(contract.code)
            ]);
            return new ContractId(contract.version, joinHashed);
        }
        else {
            throw new Error("contract is not V0");
        }
    };
    ContractId.read = function (buffer, offset) {
        var _a = Serialization_1.readVarInt(buffer, offset), version = _a.value, offset2 = _a.offset;
        var _b = Hash_1.Hash.read(buffer, offset2), cHash = _b.hash, offset3 = _b.offset;
        return { contractId: new ContractId(version, cHash), offset: offset3 };
    };
    ContractId.prototype.toJson = function () {
        return { contractId: this.toHex() };
    };
    ContractId.prototype.getHash = function () {
        if (this.cHash)
            return this.cHash;
        throw new Error("contract hash is not valid");
    };
    ContractId.prototype.getVersion = function () {
        if (this.version)
            return this.version;
        throw new Error("version is not valid");
    };
    ContractId.prototype.getSize = function () {
        return 33;
    };
    ContractId.prototype.write = function (buffer, offset) {
        //buffer.writeUInt32BE(1,offset)
        offset = Serialization_1.writeVarInt(this.version, buffer, offset);
        offset = this.cHash.write(buffer, offset);
        return offset;
    };
    ContractId.prototype.serialize = function () {
        var size = this.getSize();
        var buffer = buffer_1.Buffer.alloc(size);
        this.write(buffer, 0);
        return buffer;
    };
    ContractId.prototype.stringBuffer = function () {
        var buffer = buffer_1.Buffer.alloc(36);
        buffer.writeUInt32BE(this.version, 0);
        this.cHash.bytes.copy(buffer, 4, 0, this.getSize());
        return buffer;
    };
    ContractId.prototype.getVersionBigi = function () {
        return BigInteger.valueOf(this.version);
    };
    ContractId.prototype.hash = function () {
        var bufferVersion = buffer_1.Buffer.alloc(4);
        bufferVersion.writeUInt32BE(this.version, 0);
        var versionSha3 = js_sha3_1.sha3_256(bufferVersion);
        var bufferHash = buffer_1.Buffer.alloc(32);
        this.cHash.bytes.copy(bufferHash, 4, 0, this.getSize());
        var hashSha3 = js_sha3_1.sha3_256(bufferHash);
        return new Hash_1.Hash(js_sha3_1.sha3_256.update(versionSha3).update(hashSha3).toString());
    };
    ContractId.prototype.toHex = function () {
        return this.stringBuffer().toString('hex');
    };
    return ContractId;
}());
exports.ContractId = ContractId;
//# sourceMappingURL=ContractId.js.map